module.exports = __webpack_public_path__ + "static/media/capstone_permissions.8bf49b97.yaml";